import InitialQuestions from './intial/questions';
import FollowupQuestions from './followup/questions';

const MicroGlp1Questions = [...InitialQuestions, ...FollowupQuestions];
export type { MicroGlp1FollowupFieldAnswers } from './followup/questions';
export type { MicroGlp1FieldAnswers } from './intial/questions';
export default MicroGlp1Questions;
